module.exports = __webpack_public_path__ + "static/Logo-196e29f26eebc42e22833d20e8d3c730.png";